import { Loader2 } from 'lucide-react'

/**
 * Full-page loading spinner for lazy-loaded routes.
 * Keeps the layout visible while content loads.
 */
export function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <Loader2 className="size-8 text-white/50 animate-spin" />
    </div>
  )
}
